/**
 * Color filter swatches
 *
 * @module color-filter-swatches
 */
const component = {

    /**
     * Init component
     *
     * @returns {undefined}
     */
    init: () => {

        window.theme = window.theme || {};

        /**
         * Apply color filter swatches api
         *
         * @global
         */
        window.theme.applyColorFilterSwatches = component.apply;

        window.addEventListener('DOMContentLoaded', component.apply);
    },

    /**
     * Apply swatches to color filter options based on the Swatches section data.
     *
     * @returns {undefined}
     */
    apply: () => {

        if (!window.theme.hex_swatches || !window.theme.hex_swatches.colors) {
            return;
        }

        document.querySelectorAll('[data-color-swatch]').forEach(swatch => {

            const handle = swatch.dataset.colorSwatch;
            const match = window.theme.hex_swatches.colors.find(item => item.handle_title == handle);

            if (!match) {
                swatch.style.display = 'none';
                return;
            }

            if (match.image) {
                swatch.style.backgroundImage = `url('${match.image}')`;
                swatch.style.backgroundSize = 'cover';
                swatch.style.backgroundPosition = 'center';
            } else {
                swatch.style.backgroundColor = match.color;
            }

            swatch.style.display = '';
        });
    }
};

export default component;
